import 'ts-polyfill';
import 'core-js';

import * as React from "react";
import * as ReactDOM from "react-dom";

// =====================================
// COMPONENTS
import { App } from "./components/App";

ReactDOM.render(
    <App />,
    document.getElementById("app")
);